namespace Matrix.Workflow {

    @Serenity.Decorators.panel()
    export class ApprovalDialog extends Serenity.PropertyDialog<any, any> {

        private form = new ApprovalForm(this.idPrefix);

        private workflowInstanceId: number;
        private gridDiv: JQuery;
        private commentOnApprove: WorkflowCommentOption;
        private commentOnReject: WorkflowCommentOption;

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected arrange() {
            super.arrange();
            var availHeight = Math.max(250, $(window).height() - 350);
            this.form.DiffView.element.css('height', availHeight + 'px').trigger('layout');
            this.gridDiv && this.gridDiv.css('height', availHeight + 'px').trigger('layout');
        }

        getDialogButtons() {
            return [];
        }

        getToolbarButtons() {
            return <Serenity.ToolButton[]>[
                {
                    title: "Approve",
                    cssClass: 'approve-button',
                    icon: 'fa-check',
                    onClick: () => {
                       this.approve({
                            WorkflowInstanceId: this.workflowInstanceId
                        }, response => {
                            Q.notifySuccess(titleize(this.form.OperationCode.value) + " operation is approved.");
                            this.element.triggerHandler('ondatachange', {
                                type: 'APPROVED'
                            });
                            this.dialogClose();
                        });
                    }
                },
                {
                    title: "Reject",
                    cssClass: 'reject-button',
                    icon: 'fa-times',
                    onClick: () => {
                        this.approve({
                            WorkflowInstanceId: this.workflowInstanceId,
                            Reject: true
                        }, (response) => {
                            Q.notifyInfo(titleize(this.form.OperationCode.value) + " operation is rejected.");
                            this.element.triggerHandler('ondatachange', {
                                type: 'REJECTED'
                            });
                            this.dialogClose();
                        })
                    }
                }
            ];
        }

        private approve(request: ApprovalRequest, response: (ApprovalResponse) => void) {
            const currentCommentOption = request.Reject ? this.commentOnReject : this.commentOnApprove;

            if (currentCommentOption !== WorkflowCommentOption.None) {
                const dlg = new ApprovalCommentDialog({
                    title: (request.Reject ? "Reject" : "Approve") + " Comment",
                    required: currentCommentOption
                });

                dlg.onSuccess = (comment) => {
                    ApprovalQueueService.Approve({
                        ...request,
                        Comment: comment
                    }, response);

                    dlg.dialogClose();
                }

                dlg.dialogOpen();
                return;
            }

            ApprovalQueueService.Approve(request, response);
        }

        execute(workflowInstanceId: number) {
            ApprovalQueueService.Retrieve({
                WorkflowInstanceId: workflowInstanceId
            },
                response => {
                    this.commentOnApprove = response.ApproveCommentOption;
                    this.commentOnReject = response.RejectCommentOption;

                    this.workflowInstanceId = response.WorkflowInstanceId;
                    this.propertyGrid.load(response);

                    if (response.EntityType == "Data.AccountModelTarget" &&
                        response.RecordKey != null &&
                        response.RecordKey.indexOf(':') > 0) {
                        this.form.DiffView.element.hide();
                        this.gridDiv = $('<div/>').insertAfter(this.form.DiffView.element).css({
                            'width': '100%'
                        });
                        var grid = new Data.AccountModelTargetGrid(this.gridDiv, {
                            modelCode: response.RecordKey.split(':')[0],
                            modelName: '',
                            accountCode: response.RecordKey.split(':')[1]
                        });
                        if (!(response.CanApprove || response.CanReject)) {
                            grid["preventSubmit"] = 999999999;
                            var extraData = (response.ExtraData || {});
                            var model = (extraData.Model || {});
                            var modelTargets = (extraData.ModelTargets || []);
                            grid.insertRoot(modelTargets, model);
                            grid.setItems(modelTargets);
                            grid.applyAccountModelTargets(model, extraData.AccountModelTargets || [], {
                                WorkflowInstanceId: response.WorkflowInstanceId,
                                CanApprove: false,
                                CanReject: false,
                                PendingOperation: null,
                                Targets: (response.Request || {}).Targets || []
                            });
                            grid["toolbar"].findButton('.export-xlsx-button').remove();
                            grid["toolbar"].findButton('.refresh-button').remove();
                        }
                        grid.editItem = () => false;
                        grid["account"].element.hide().prev('.select2-container').hide();
                        grid["toolbar"].findButton('.approve-changes-button').closest('.buttons-inner').hide();
                        grid["toolbar"].findButton('.approve-changes-button').closest('.buttons-inner').hide();
                        grid["toolbar"].findButton('.fileinput-button').remove();
                        grid["toolbar"].findButton('.delete-all-button').remove();
                        this.gridDiv.find('.grid-title').hide();
                    }
                    else {
                        this.form.DiffView.setDiff(response.OldValues, response.NewValues, response.FieldTitles);
                    }
                    this.toolbar.findButton('approve-button').toggle(response.CanApprove);
                    this.toolbar.findButton('reject-button').toggle(response.CanReject);
                    var pending = response.StatusCode && response.StatusCode == ApprovalConsts.PendingStatus;
                    this.form.StatusCode.getGridField().toggle(!pending);
                    this.form.StatusDescription.getGridField().toggle(!pending);
                    this.form.UpdatedBy.getGridField().toggle(!pending);
                    this.form.UpdatedWhen.getGridField().toggle(!pending);
                    this.form.ApproveRejectComment.getGridField().toggle(!pending);
                    this.dialogTitle = this.form.EntityType.text + " - " + titleize(this.form.OperationCode.value) + " Approval";
                    this.dialogOpen();
                });
        }

        getTemplate() {
            return `<div>
    <div class="s-Form">
        <div id="~_Toolbar"></div>
        <form id="~_Form" action="">
            <div class="fieldset">
                <div id="~_PropertyGrid"></div>
            </div>
        </form> 
    </div>
</div>`;
        }

    }
}

namespace Matrix {

    export function titleize(str: string) {
        var str_arr = str.split('_');
        for (var x = 0; x < str_arr.length; x++)
            str_arr[x] = str_arr[x].charAt(0).toUpperCase() + str_arr[x].substring(1).toLowerCase();
        return str_arr.join(' ');
    }
}